import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NotificationDTO, NotificationState } from 'types';
import dayjs from 'dayjs';
import { getNotifications, markSeen, deleteAllSeenNotification, deleteAllNotification } from './notificationActions';
import { isUndefined } from 'utils/commonUtils';

const initialState: NotificationState = {
    notifications: [],
    loading: false,
};

const notificationsSlice = createSlice({
    name: 'notif',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // fetch
            .addCase(getNotifications.pending, (state) => {
                state.loading = true;
            })
            .addCase(getNotifications.fulfilled, (state, action: PayloadAction<NotificationDTO[]>) => {
                state.notifications = action.payload;
                state.loading = false;
            })
            .addCase(getNotifications.rejected, (state) => {
                state.loading = false;
            })

            .addCase(markSeen.pending, (state) => {
                state.loading = true;
            })
            .addCase(markSeen.fulfilled, (state, action: PayloadAction<number>) => {
                const notif = state.notifications.find((n) => n.id === action.payload);
                if (notif) notif.seen_at = dayjs().toString();
                state.loading = false;
            })
            .addCase(markSeen.rejected, (state) => {
                state.loading = false;
            })

            .addCase(deleteAllSeenNotification.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteAllSeenNotification.fulfilled, (state) => {
                state.notifications = state.notifications.filter((n) => isUndefined(n.seen_at));
                state.loading = false;
            })
            .addCase(deleteAllSeenNotification.rejected, (state) => {
                state.loading = false;
            })

            .addCase(deleteAllNotification.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteAllNotification.fulfilled, (state) => {
                state.notifications = [];
                state.loading = false;
            })
            .addCase(deleteAllNotification.rejected, (state) => {
                state.loading = false;
            });
    },
});

export default notificationsSlice.reducer;
